// extracted by mini-css-extract-plugin
export default {"emptyContainer":"noData_emptyContainer__JJ3qm"};